import type { ExtractPropTypes } from "vue";
export const SelectSearchPropsOption = {
    modelValue: { type: String, required: true },
    placeholder: { type: String },
    style: { type: String, default: "style1" },
    navigation: { type: Boolean, default: false },
} as const;

export type SelectSearchProps = ExtractPropTypes<typeof SelectSearchPropsOption>;

export const SelectSearchEmits = {
    "search": (_keyword: string, _mode: string, _id?: string) => true,
    "update:modelValue": (_keyword: string) => true,
};
